import { Popover } from "bootstrap";

/**
 * Created by cc on 13.07.2017.
 */
export const AdvancedTooltip = (() => {
    "use strict";
    var returnObj = {};

    returnObj.init = function ($selector) {
        if (!$selector) {
            $selector = $(document);
        } else if (!($selector instanceof $)) {
            $selector = $($selector);
        }

        $selector.siblings().off('mouseover click', '.advancedtooltip');
        $selector.siblings().on('mouseover click', '.advancedtooltip', function (e) {
            const target = e.target;
            [...target].map(target => Popover.getOrCreateInstance(target, {
                animation: true,
                container: $target.data('setu-attach') || $target.parent(),
                content: $('.' + $target.data('setu-contentclass')).html(),
                html: true,
                placement: 'bottom',
                trigger: 'manual',
                sanitize: false,
            }));

        });

        $selector.siblings().off('mouseout', '.advancedtooltip');
        $selector.siblings().on('mouseout', '.advancedtooltip', function (e) {
            const popover = Popover.getOrCreateInstance(e.target);
            popover.hide();
        });
    };

    return returnObj;
})();
